import { gql } from '@apollo/client';

export const billingItemsFragment = gql`
  fragment BillingFeatures on ArtistBillingFeatureModel {
    __typename
    artistId
    credit
    itemCode
  }
`;
